import React from 'react'
import ManagePay from '../DashboardPage/managePay/ManagePay'
import './managepayPage.css'

import DashboardLayout from '../../components/DashboardLayout/DashboardLayout'
// Width-based views (<=1194px => MobileView) so tablets get the same mobile
// Manage Donations layout (incl. the "Connect Stripe/PayPal in Connect Payments"
// empty state) as phones, instead of the UA-based desktop layout.
import { BrowserView, MobileView } from '../../components/responsiveView'
import MobileTopBar from '../../components/common/MobileTopBar'
// import { Link } from 'react-router-dom'

const ManagepayPage = () => {



  return (
    <>
      <BrowserView style={{ height: '100%' }}>
        <DashboardLayout>
          <ManagePay />
        </DashboardLayout>
      </BrowserView>
      <MobileView>
        <MobileTopBar />
        <ManagePay />
      </MobileView>
      {/* {redux.displayWelcomeMessage.show !== false && (
        <WelcomePopup closePopup={closeWelcomeMessage} />
      )} */}


    </>
  )
}

export default ManagepayPage